import type { FC } from "react";
import styled from "styled-components";
import Icon from "@components/Icon";

const colours = { MIDNIGHT_BLUE: "#121252" };

/* Same as ContactSupportInfo: #F3F3F3, 1px dashed border */
const Container = styled.div`
	width: 100%;
	box-sizing: border-box;
	margin: 24px 0;
	padding: 10px;
	background-color: #f3f3f3;
	border: 1px dashed #000000;
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
	gap: 10px;
`;

const IconWrapper = styled.div`
	flex-shrink: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 40px;
	height: 40px;
`;

const TextBlock = styled.p`
	font-family: var(--euclid-regular);
	font-size: 14px;
	font-weight: 400;
	line-height: 1.5;
	color: ${colours.MIDNIGHT_BLUE};
	margin: 0;
	flex: 1;
	min-width: 0;
`;

const Bold = styled.span`
	font-weight: 700;
	font-size: inherit;
`;

const RememberInfo: FC = () => {
	return (
		<Container>
			<IconWrapper>
				<Icon
					iconName="remember"
					iconSizes={{
						iconMobile: 40,
						iconTablet: 40,
						iconLaptop: 40,
						iconDesktop: 40,
						iconDesktopLarge: 40,
					}}
					alt=""
				/>
			</IconWrapper>
			<TextBlock>
				<Bold>Remember:</Bold> Keep your current provider's SIM in your phone
				until your switch is completed.
			</TextBlock>
		</Container>
	);
};

export default RememberInfo;
